"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function isTestEnv() {
  return !!(process && process.env && process.env.NODE_ENV === 'test');
}
var context = isTestEnv() ? {
  keys: function keys() {
    return [];
  }
} : require.context('resources/assets/js', true, /^\.\/vendor\/spriteVideos\/([^/]+\/){1}index\.js$/);
var _default = exports["default"] = context.keys().map(function (key) {
  var result = context(key);
  return result["default"] ? result["default"] : result;
});